import { Components, radioClasses, SvgIcon, Theme } from '../../material';

const radioSize = 20;

const RadioUncheckedIcon = (
  <SvgIcon sx={{ fontSize: radioSize }}>
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5" />
  </SvgIcon>
);

const RadioCheckedIcon = (
  <SvgIcon sx={{ fontSize: radioSize }}>
    <circle cx="12" cy="12" r="10" fill="currentColor" />
    <circle cx="12" cy="12" r="4" fill="white" />
  </SvgIcon>
);

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  defaultProps: {
    disableRipple: true,
    size: 'small',
    icon: RadioUncheckedIcon,
    checkedIcon: RadioCheckedIcon,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1),
      color: theme.palette.secondary.light,
      '& .MuiTouchRipple-root': {
        display: 'none',
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      [`&.${radioClasses.checked}`]: {
        color: theme.palette.primary.main,
        '&:hover': {
          color: theme.palette.primary.dark,
        },
      },
      [`&.${radioClasses.disabled}`]: {
        color: theme.palette.action.disabled,
        [`&.${radioClasses.checked}`]: {
          '& .MuiSvgIcon-root circle:first-child': {
            fill: theme.palette.action.disabledBackground,
            stroke: theme.palette.action.disabled,
            strokeWidth: 1.5,
          },
          '& .MuiSvgIcon-root circle:last-child': {
            fill: theme.palette.text.disabled,
          },
        },
      },
    }),
  },
};
